import React from "react";
import { FloorEditState } from "../../../../state/floor/floor-edit-state";
import FloorDetailRepositionImage from "./floor-detail-reposition-image";
import FloorDetailHome from "./floor-detail-home";

export interface FloorDetailProps {
	floorEditState: FloorEditState;
}

export default function FloorDetail(props: FloorDetailProps) {
	if (props.floorEditState.isPositioning) {
		return <FloorDetailRepositionImage state={props.floorEditState} />;
	} else {
		return <FloorDetailHome state={props.floorEditState} />;
	}
}
